import { render, staticRenderFns } from "./FileDragAndDrop.vue?vue&type=template&id=4154061a&scoped=true"
import script from "./FileDragAndDrop.vue?vue&type=script&lang=js"
export * from "./FileDragAndDrop.vue?vue&type=script&lang=js"
import style0 from "./FileDragAndDrop.vue?vue&type=style&index=0&id=4154061a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4154061a",
  null
  
)

/* custom blocks */
import block0 from "./FileDragAndDrop.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports